export default __webpack_public_path__ + "static/media/logo.e240c342.svg";